module.exports = "textarea {\n  /*resize: none;*/\n  height: 10px;\n}"